
  
  <powerbi-report [embedConfig]="reportConfig" [cssClassName]="reportClass">
  </powerbi-report>

  <dx-load-panel id="pnlLoad"
                 shadingColor="rgba(0,0,0,0.4)"
                 [position]="{ at: 'center' }"
                 [(visible)]="__bIsLoadingVisible"
                 [showIndicator]="true"
                 [showPane]="true"
                 [shading]="true"
                 [hideOnOutsideClick]="false"
                 [height]="75"
                 [width]="150"
                 message="Please Wait...">
  </dx-load-panel>

